import { createSelector } from 'reselect';

import * as utils from './../../util';
import * as constants from './../../constants';
import * as urlQueryString from './../../urlQueryString';
import { eventMetaDataSelector } from '../common/tracking/selectors';
import { TRACKING_SUB_AREA } from '../../trackingV2';
import { selectors } from '../filterBar';
import { FAILURE_ANALYSIS_PATTERNS_FILTER_MAP } from '../failure-analysis/constants';

const routerLocation = (store) => store.router.location;
const rootCausesStore = (store) => store.apps.analytics.rootCauses;

export const rootCausesSelector = createSelector(
  rootCausesStore,
  routerLocation,
  eventMetaDataSelector,
  (rootCauses, location, eventMetaData) => ({
    loadingData: ['idle', 'loading'].includes(rootCauses.get('fetchStatus')),
    items: rootCauses.get('items'),
    selectedTest: rootCauses.get('selectedTest'),
    getRootCauseError: rootCauses.get('getRootCauseError'),
    patternIdQueryString: urlQueryString.get(
      location, constants.ROOTCAUSE_QUERY_STRINGS.PATTERN_ID,
    ),
    eventMetaData: {
      ...eventMetaData,
      product_sub_area: TRACKING_SUB_AREA.FAILURE_ANALYSIS,
    },
  }));

export const initFilterSelector = createSelector([
  routerLocation,
], (location) => {
  const selectedTest = urlQueryString.get(location, constants.ROOTCAUSE_QUERY_STRINGS.TEST_HASH);
  return selectedTest ? utils.parseJSON(selectedTest) : null;
});

export const selectTestParamsSelector = createSelector([
  routerLocation,
  (store, options) => options,
], (location, options) => (!options ?
  urlQueryString.remove(location, [
    constants.ROOTCAUSE_QUERY_STRINGS.TEST_HASH,
    constants.ROOTCAUSE_QUERY_STRINGS.PATTERN_ID,
  ]) :
  urlQueryString.set(location, {
    [constants.ROOTCAUSE_QUERY_STRINGS.TEST_HASH]: JSON.stringify(options.test),
    [constants.ROOTCAUSE_QUERY_STRINGS.PATTERN_ID]: options.pattern,
  })));

export const rootCauseDataSelector = createSelector([
  rootCausesStore,
  (store, options) => options,
], (rootCauses, options) => rootCauses.getIn(['items', options.patternId]));

export const rootCauseAdditionalDataSelector = createSelector([
  rootCausesStore,
  (store, options) => options,
], (rootCauses, options) => {
  const rootCauseItem = rootCauses.getIn(['items', options.patternId]);

  if (!rootCauseItem) {
    return {
      isDataExists: false,
    };
  }

  const annotations = rootCauseItem.getIn(['annotations', 'data']);
  const jobs = rootCauseItem.getIn(['jobs', 'data']);
  return {
    isDataExists: !!(annotations?.length && jobs?.length),
  };
});

export const queryParamSelector = createSelector([
  selectors.selectRequestParams(FAILURE_ANALYSIS_PATTERNS_FILTER_MAP),
  (store, options) => options,
],
(filterParams, options = {}) => ({
  ...filterParams,
  ...options,
}));
